@if (loading()) {
  <div class="soft-ds-progress-bar__track">
    <soft-ds-loading-skeleton class="soft-ds-progress-bar__skeleton" />
  </div>
  @if (variant() === 'segmented' && showLegend()) {
    <ul class="soft-ds-progress-bar__legend" aria-hidden="true">
      @for (_ of legendPlaceholderRange(); track $index) {
        <li class="soft-ds-progress-bar__legend-item">
          <span class="soft-ds-progress-bar__legend-dot"></span>
          <soft-ds-loading-skeleton
            class="soft-ds-progress-bar__legend-skeleton"
          />
        </li>
      }
    </ul>
  }
} @else if (variant() === 'percent') {
  <div class="soft-ds-progress-bar__track">
    <div
      class="soft-ds-progress-bar__fill"
      [style.width]="'min(100%, ' + (percentFill() * scale()) + '%)'"
      [style.background]="percentFillStyle()"
    ></div>
    @if (markerPercent() !== null) {
      <div
        class="soft-ds-progress-bar__marker"
        [style.left.%]="(markerPercent() ?? 0) * scale()"
      ></div>
    }
  </div>
} @else {
  <div class="soft-ds-progress-bar__segments">
    @for (s of visibleSegments(); track $index) {
      @if (clickableSegments()) {
        <button
          type="button"
          class="soft-ds-progress-bar__segment soft-ds-progress-bar__segment--clickable"
          [style.width.%]="segmentPercent(s)"
          [style.background]="segmentBackground(s)"
          [attr.aria-label]="s.label ?? null"
          (click)="$event.stopPropagation(); segmentClick.emit(s)"
        ></button>
      } @else {
        <span
          class="soft-ds-progress-bar__segment"
          [style.width.%]="segmentPercent(s)"
          [style.background]="segmentBackground(s)"
          aria-hidden="true"
        ></span>
      }
    }
  </div>

  @if (showLegend()) {
    <ul class="soft-ds-progress-bar__legend">
      @for (s of segments(); track $index) {
        @if (clickableSegments()) {
          <li class="soft-ds-progress-bar__legend-item">
            <button
              type="button"
              class="soft-ds-progress-bar__legend-button"
              (click)="$event.stopPropagation(); segmentClick.emit(s)"
            >
              <span
                class="soft-ds-progress-bar__legend-dot"
                [style.background]="segmentBackground(s)"
                aria-hidden="true"
              ></span>
              <span class="ds-caption soft-ds-progress-bar__legend-count">
                {{ s.value | number: '1.0-0' }}
              </span>
              @if (s.label) {
                <span class="ds-caption soft-ds-progress-bar__legend-label">
                  {{ s.label }}
                </span>
              }
            </button>
          </li>
        } @else {
          <li class="soft-ds-progress-bar__legend-item">
            <span
              class="soft-ds-progress-bar__legend-dot"
              [style.background]="segmentBackground(s)"
              aria-hidden="true"
            ></span>
            <span class="ds-caption soft-ds-progress-bar__legend-count">
              {{ s.value | number: '1.0-0' }}
            </span>
            @if (s.label) {
              <span class="ds-caption soft-ds-progress-bar__legend-label">
                {{ s.label }}
              </span>
            }
          </li>
        }
      }
    </ul>
  }
}
